exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.extra-rounded[data-v-41050944] {\n  list-style: none;\n}\n.icon-holder .label[data-v-41050944] {\n  display: block;\n  font-size: 12px;\n  font-weight: bold;\n  text-align: center;\n  padding-top: 2px;\n}\n.col_content .head[data-v-41050944] {\n  font-size: 0.9rem;\n}\n.col_content .head .label[data-v-41050944] {\n    font-weight: bold;\n}\n.col_content .head .label.is-hidden[data-v-41050944] {\n      opacity: 0;\n}\n", ""]);

// exports
